import React from "react";
import "./introImg.css";
export default function IntroImg() {
  return (
    <div className="introCard" id="home">
      <div className="titleCard">
        <h2>Namaste</h2>
        <span className="namaste">🙏</span>
        <h4> I'm Rajesh Gautam</h4>
      </div>
      <div className="imgCard">
        <img src="../images/introImg.jpg" alt="MyPicture" />
      </div>
      <div className="subTitleCard">
        <p>
          Welcome! I'm a software developer specializing in the Full-Stack,
          driven by a relentless pursuit of solving complex challenges and
          leveraging my expertise to drive business growth as well as personal
          development. I thrive on applying my skills to craft dynamic,
          user-centric applications that seamlessly blend creativity with
          functionality. From conceptualization to deployment, join me on this
          journey of transforming ideas into impactful realities.
        </p>
        {/* <p>
          👣 My coding journey began after I completed my associate degree in
          Information Technology from my local community college 🏫 CCBC. Eager
          to delve deeper into the world of coding ⌨️, I took the plunge and
          enrolled in John Hopkins University's Coding Boot Camp 💻
        </p>
        <ul>
          <li>
            🎓 Graduated from John Hopkins University's Coding Boot Camp and
            later obtained a Computer Science Degree from Wilmington University
            🏫
          </li>
          <li>
            👨🏻‍💻 Constantly expanding skills, exploring tech, and eager to
            collaborate on impactful projects 📊
          </li>
          <li>
            🌱 Let's connect, collaborate, and code something awesome together🙏
          </li>
        </ul> */}
      </div>
    </div>
  );
}
